/* Comprobador «¿Lista para agentes de IA?» de lineagrafica.es (repo LINEA-GRAFICA/lg-web-tools, carpeta tema-ia/).
   Pinta la sección lg-tool-ia contra https://tools.lineagrafica.es/api/agentes: formulario, etapas mientras analiza,
   vista del agente (captura con rayos X frente a lo que lee), recorrido animado, voz del agente, grupos, UCP y lead. */
(function () {
  var root = document.querySelector('[data-lgia]');
  if (!root) return;
  var API = root.getAttribute('data-api');
  var LOC = root.getAttribute('data-lang') || 'es';
  var LANG = LOC.split('-')[0].toLowerCase();
  var ALL = window.LGIA_I18N || {};
  var T = ALL[LOC] || ALL[LANG] || ALL.es || {};
  var BASE = ALL.es || {};
  var PRIVACY = root.getAttribute('data-privacy') || '/policies/privacy-policy';
  var PS_URL = root.getAttribute('data-ps-module') || '';
  var app = root.querySelector('[data-lgia-app]');
  var out = root.querySelector('[data-lgia-out]');
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAGES = ['home', 'catalog', 'product', 'browser', 'ai'];
  var ORDEN = { fail: 0, warn: 1, probable: 2, na: 3, ok: 4, info: 5 };
  // Puntos que arregla el módulo PrestaShop lgagentready (solo si su interruptor está encendido).
  var MODULO_ARREGLA = { ucp_profile: 1, product_data: 1, gtin: 1, ucp_gtin: 1, brand: 1, stock: 1, refund: 1, shipping: 1, terms: 1, ucp_returns: 1, cart_endpoint: 1, llms: 1 };
  // Ítems informativos o grises que llevan explicación; el resto (p. ej. variantes cuando no hay) va sin texto.
  var INFO_TXT = { llms: 1, webmcp: 1, robots_training: 1, ucp_region: 1, ucp_merchant: 1, consent_ucp: 1 };
  var actual = null, sondeo = null;

  function t(ruta, vars) {
    var get = function (o) { return ruta.split('.').reduce(function (a, k) { return a && a[k] != null ? a[k] : undefined; }, o); };
    var s = get(T);
    if (s == null) s = get(BASE);
    if (s == null) s = '';
    return String(s).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function dec(s) { var d = document.createElement('textarea'); d.innerHTML = String(s || ''); return d.value; }
  function ga(ev, p) {
    try { if (window.gtag) window.gtag('event', ev, p); else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, p)); } catch (e) {}
  }
  function api(ruta, opts) {
    return fetch(API + ruta, Object.assign({ credentials: 'omit' }, opts || {})).then(function (r) {
      if (r.status === 429) return { ok: false, error: 'rate' };
      return r.json().catch(function () { return { ok: false, error: 'generic' }; });
    }, function () { return { ok: false, error: 'generic' }; });
  }
  function ico(st) { return { ok: '✓', probable: '✓', warn: '!', fail: '✕', na: '?', info: 'i', skip: '–' }[st] || '·'; }
  function nivel(n) { return n >= 80 ? 'high' : n >= 50 ? 'mid' : 'low'; }
  // un grupo sin nada medible (p. ej. sin ficha de producto) llega como null
  function num(n) { return n == null ? '—' : n; }
  function visible(el, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); fn(); } }, { threshold: 0.25 });
    io.observe(el);
  }

  /* ---------- Formulario ---------- */
  app.innerHTML = '<form class="lgia__form" novalidate><label class="lgia__sr" for="lgia-url">' + esc(t('label')) + '</label>' +
    '<input id="lgia-url" type="text" inputmode="url" autocomplete="url" spellcheck="false" maxlength="200" placeholder="' + esc(t('placeholder')) + '">' +
    '<button class="lgia__btn" type="submit">' + esc(t('button')) + '</button></form><p class="lgia__note">' + esc(t('note')) + '</p>';
  var form = app.querySelector('form'), input = app.querySelector('input'), btn = app.querySelector('button');
  var q = new URLSearchParams(location.search).get('url');
  if (q) input.value = q.slice(0, 200);
  // Versión interna (página no enlazada, data-interno): pide la URL (dominio, enlace de vista previa compartido o la de
  // proyectos-lineagrafica.com) y, solo si la tienda lo pide, la contraseña de Shopify o el usuario y la contraseña de basic
  // auth: lo detecta /api/interno/acceso. Lo de la tienda solo viaja en el cuerpo del POST a /api/agentes/interno y no se
  // guarda en ningún sitio. Sin token: basta con que la página no se indexe (Jose, 19/10/2026).
  var INTERNO = root.hasAttribute('data-interno') ? interno() : null;
  function interno() {
    var campo = function (id, txt, tipo) { return '<label class="lgia__in-f"><span>' + txt + '</span><input id="lgia-' + id + '" type="' + tipo + '" autocomplete="' + (tipo === 'password' ? 'new-password' : 'off') + '" spellcheck="false" maxlength="200"></label>'; };
    var box = document.createElement('div');
    box.className = 'lgia__interno';
    box.innerHTML = '<p class="lgia__in-info" hidden></p>' +
      '<div data-k="password" hidden>' + campo('password', 'Contraseña de la tienda', 'password') + '</div>' +
      '<div data-k="basic" hidden>' + campo('user', 'Usuario', 'text') + campo('pass', 'Contraseña', 'password') + '</div>';
    form.insertAdjacentElement('afterend', box);
    input.maxLength = 500;
    var parte = function (k) { return box.querySelector('[data-k="' + k + '"]'); };
    var v = function (id) { return box.querySelector('#lgia-' + id).value; };
    var info = box.querySelector('.lgia__in-info');
    function pide(k) { parte('password').hidden = k !== 'password'; parte('basic').hidden = k !== 'basic'; }
    function aviso(txt) { info.textContent = txt || ''; info.hidden = !txt; }
    var espera, ultima = '';
    function sondear() {
      var url = input.value.trim();
      if (!url || url === ultima) return;
      ultima = url;
      api('/api/interno/acceso', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ url: url }) }).then(function (r) {
        if (input.value.trim() !== url) return;
        if (!r.ok) return aviso(r.error === 'preview' ? ERR_INTERNO.preview : '');
        pide(r.needs);
        aviso([r.host, r.preview ? 'vista previa' : '', r.needs === 'password' ? 'con contraseña' : r.needs === 'basic' ? 'con usuario y contraseña' : ''].filter(Boolean).join(' · '));
      });
    }
    input.addEventListener('input', function () { clearTimeout(espera); espera = setTimeout(sondear, 700); });
    input.addEventListener('blur', sondear);
    if (input.value) sondear();
    return {
      pide: pide,
      datos: function () {
        var d = {};
        if (!parte('password').hidden) d.password = v('password');
        if (!parte('basic').hidden) { d.user = v('user').trim(); d.pass = v('pass'); }
        return d;
      }
    };
  }
  var ERR_INTERNO = { password: 'La tienda tiene contraseña: escríbela y vuelve a comprobar.', auth: 'La tienda pide usuario y contraseña (o los que has puesto no valen).',
    preview: 'Ese enlace de vista previa no lleva a ninguna tienda (puede haber caducado).', credentials: 'Revisa el usuario y la contraseña (el usuario no puede llevar «:»).' };

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var v = input.value.trim();
    if (!v) { input.focus(); return; }
    lanzar(v);
  });

  // v=2: detección estricta, vía genérica, tope de la nota y captcha (interruptor del servidor hasta el OK de Jose).
  function lanzar(url, cf) {
    btn.disabled = true;
    cargando('home');
    out.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    (INTERNO ? api('/api/agentes/interno', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(Object.assign({ url: url, lang: LANG }, INTERNO.datos())) })
      : api('/api/agentes?url=' + encodeURIComponent(url) + '&lang=' + LANG + '&v=2' + (cf ? '&cf=' + encodeURIComponent(cf) : ''))).then(function (r) {
      if (r.error === 'captcha') { btn.disabled = false; out.innerHTML = ''; return pedirCaptcha(url, r); }
      if (r.error === 'limit') { btn.disabled = false; return limite(r); }
      if (!r.ok || !r.id) { btn.disabled = false; return error(r.error); }
      ga('ia_check_run', { cached: !!r.cached });
      seguir(r.id);
    });
  }
  function seguir(id) {
    var inicio = Date.now();
    clearTimeout(sondeo);
    (function paso() {
      api('/api/agentes/r/' + encodeURIComponent(id) + '?lang=' + LANG).then(function (r) {
        if (r && r.state === 'running') {
          cargando(r.stage, r.host);
          if (Date.now() - inicio > 150000) { btn.disabled = false; return error('timeout'); }
          sondeo = setTimeout(paso, 1400);
          return;
        }
        btn.disabled = false;
        out.removeAttribute('data-wait'); out.removeAttribute('aria-busy');
        if (!r || !r.ok) return error(r && r.error);
        try { history.replaceState(null, '', '#r=' + id); } catch (e) {}
        actual = r;
        pintar(r);
      });
    })();
  }

  /* ---------- Etapas ---------- */
  function cargando(stage, host) {
    var i = Math.max(0, STAGES.indexOf(stage));
    var box = out.querySelector('.lgia__stages');
    if (!box) {
      out.innerHTML = '<div class="lgia__card lgia__stages"><div class="lgia__scan" aria-hidden="true"><span></span></div><p class="lgia__stages-host"></p><ol>' +
        STAGES.map(function (s) { return '<li data-s="' + s + '"><span class="lgia__dot"></span>' + esc(t('stages.' + s)) + '</li>'; }).join('') + '</ol></div>';
      box = out.querySelector('.lgia__stages');
    }
    if (host) box.querySelector('.lgia__stages-host').textContent = host;
    [].forEach.call(box.querySelectorAll('li'), function (li, k) { li.className = k < i ? 'is-done' : k === i ? 'is-now' : ''; });
  }
  /* ---------- Captcha (Cloudflare Turnstile): desde la 3.ª comprobación seguida ---------- */
  var tsCarga = null;
  function turnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!tsCarga) tsCarga = new Promise(function (ok, ko) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { window.turnstile ? ok(window.turnstile) : ko(); };
      s.onerror = function () { tsCarga = null; ko(); };
      document.head.appendChild(s);
    });
    return tsCarga;
  }
  function pedirCaptcha(url, r) {
    var previo = document.activeElement;
    var m = document.createElement('div');
    m.className = 'lgia lgia__modal';
    m.innerHTML = '<div class="lgia__modal-box" role="dialog" aria-modal="true" aria-labelledby="lgia-cap-t" aria-describedby="lgia-cap-d" tabindex="-1">' +
      '<div class="lgia__avatar" aria-hidden="true">' + ROBOT + '</div><h2 class="lgia__h2" id="lgia-cap-t">' + esc(t('captcha.title')) + '</h2>' +
      '<p class="lgia__sub" id="lgia-cap-d">' + esc(t('captcha.text')) + '</p>' +
      '<div class="lgia__ts" data-ts></div><p class="lgia__modal-err" role="alert">' + (r.bad ? esc(t('captcha.bad')) : '') + '</p>' +
      '<button type="button" class="lgia__btn lgia__btn--ghost" data-cancel>' + esc(t('captcha.cancel')) + '</button></div>';
    document.body.appendChild(m);
    var box = m.querySelector('.lgia__modal-box'), err = m.querySelector('.lgia__modal-err'), wid = null;
    var cerrar = function () {
      document.removeEventListener('keydown', tecla);
      try { if (wid != null && window.turnstile) window.turnstile.remove(wid); } catch (e) {}
      m.remove();
      if (previo && previo.focus) previo.focus();
    };
    var tecla = function (ev) {
      if (ev.key === 'Escape') cerrar();
      if (ev.key === 'Tab') { // foco dentro del modal
        var f = [].slice.call(box.querySelectorAll('button, iframe, [tabindex="0"]'));
        if (!f.length) return;
        if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
        else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
      }
    };
    document.addEventListener('keydown', tecla);
    m.addEventListener('click', function (ev) { if (ev.target === m) cerrar(); });
    m.querySelector('[data-cancel]').addEventListener('click', cerrar);
    box.focus();
    ga('ia_check_captcha', {});
    turnstile().then(function (ts) {
      wid = ts.render(m.querySelector('[data-ts]'), {
        sitekey: r.sitekey, language: LOC.toLowerCase(), theme: 'light', action: 'ia_check',
        callback: function (tok) { cerrar(); lanzar(url, tok); },
        'error-callback': function () { err.textContent = t('captcha.fail'); }
      });
    }, function () { err.textContent = t('captcha.fail'); });
  }

  // Límite antiabuso (5 cada 10 min por IP y navegador): modal con la cuenta atrás y, al acabar, otro que avisa de
  // que ya se puede seguir, sin recargar.
  function aviso(id, cuerpo, boton) {
    var previo = document.activeElement, m = document.createElement('div');
    m.className = 'lgia lgia__modal';
    m.innerHTML = '<div class="lgia__modal-box lgia__aviso" role="dialog" aria-modal="true" aria-labelledby="' + id + '-t" aria-describedby="' + id + '-d" tabindex="-1">' +
      '<div class="lgia__avatar" aria-hidden="true">' + ROBOT + '</div>' + cuerpo + '<button type="button" class="lgia__btn" data-ok>' + esc(boton) + '</button></div>';
    document.body.appendChild(m);
    var box = m.querySelector('.lgia__modal-box'), ok = m.querySelector('[data-ok]');
    var tecla = function (ev) {
      if (ev.key === 'Escape') cerrar();
      if (ev.key === 'Tab') { ev.preventDefault(); ok.focus(); } // un solo botón: el foco no sale del modal
    };
    var cerrar = function () { document.removeEventListener('keydown', tecla); m.remove(); if (previo && previo.focus) previo.focus(); };
    document.addEventListener('keydown', tecla);
    m.addEventListener('click', function (ev) { if (ev.target === m) cerrar(); });
    ok.addEventListener('click', function () { cerrar(); });
    ok.focus();
    return { m: m, box: box, ok: ok, cerrar: cerrar };
  }
  var espera = null;
  function mmss(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function limite(r) {
    ga('ia_check_limit', {});
    out.innerHTML = '';
    var fin = Date.now() + ((r.wait_s || (r.wait || 10) * 60) + 1) * 1000;
    if (espera) clearInterval(espera.reloj);
    var md = aviso('lgia-lim', '<h2 class="lgia__h2" id="lgia-lim-t">' + esc(t('limit.title')) + '</h2>' +
      '<p class="lgia__sub" id="lgia-lim-d">' + esc(t('limit.text', { max: r.max || 5 })) + ' ' + esc(t('limit.later')) + '</p>' +
      '<p class="lgia__cuenta"><span>' + esc(t('limit.left')) + '</span> <b data-t aria-live="off">' + mmss(fin - Date.now()) + '</b></p>', t('limit.ok'));
    espera = { fin: fin, md: md };
    espera.reloj = setInterval(function () {
      var falta = fin - Date.now(), b = md.box.querySelector('[data-t]');
      if (b) b.textContent = mmss(falta);
      if (falta > 0) return;
      clearInterval(espera.reloj); espera = null;
      if (document.body.contains(md.m)) md.cerrar();
      ga('ia_check_limit_ready', {});
      var listo = aviso('lgia-ok', '<h2 class="lgia__h2" id="lgia-ok-t">' + esc(t('limit.ready_title')) + '</h2>' +
        '<p class="lgia__sub" id="lgia-ok-d">' + esc(t('limit.ready_text')) + '</p>', t('limit.ready_ok'));
      listo.ok.addEventListener('click', function () { var i = document.getElementById('lgia-url'); if (i) i.focus(); });
    }, 1000);
  }
  function error(code) {
    if (INTERNO && ERR_INTERNO[code]) { INTERNO.pide(code === 'auth' ? 'basic' : code); out.innerHTML = '<div class="lgia__card lgia__msg lgia__msg--err" role="alert">' + esc(ERR_INTERNO[code]) + '</div>'; return; }
    var k = ['url', 'unreachable', 'blocked', 'password', 'rate', 'timeout'].indexOf(code) >= 0 ? code : 'generic';
    out.innerHTML = '<div class="lgia__card lgia__msg lgia__msg--err" role="alert">' + esc(t('errors.' + k)) + '</div>';
  }

  /* ---------- Resultado ---------- */
  function pintar(r) {
    var ai = r.ai || {};
    var lvl = nivel(r.score);
    var h = '';
    // Cabecera con la nota
    h += '<section class="lgia__card lgia__top lgia--' + lvl + '"><div class="lgia__ring" style="--p:0" data-score="' + r.score + '"><svg viewBox="0 0 120 120" aria-hidden="true"><circle cx="60" cy="60" r="52"/><circle class="lgia__ring-v" cx="60" cy="60" r="52"/></svg>' +
      '<div><b data-count>0</b><small>/100</small></div></div><div class="lgia__top-txt"><p class="lgia__kicker">' + esc(t('score')) + '</p>' +
      '<h2>' + esc(r.host) + ' <span class="lgia__plat">' + esc(t('platforms.' + (r.platform || 'otra'))) + '</span></h2>' +
      '<p class="lgia__level">' + esc(t('level_' + lvl)) + '</p>' +
      (r.platform_unknown ? '<p class="lgia__generic">' + esc(t('generic_note')) + '</p>' : '') +
      (ai.summary ? '<p class="lgia__summary">' + esc(ai.summary) + '</p>' : '') +
      '<div class="lgia__acts"><a class="lgia__btn" href="#lgia-lead">' + esc(t('lead.send')) + '</a><button type="button" class="lgia__btn" data-share>' + esc(t('pdf')) + '</button></div>' +
      '<div class="lgia__groups-mini">' + ['buy', 'understand', 'trust'].map(function (g) {
        var n = r.groups[g];
        return '<div><span>' + esc(t('groups.' + g + '.t')) + '</span><i class="lgia__bar lgia--' + nivel(n) + '"><i style="width:' + (n || 0) + '%"></i></i><b>' + num(n) + '</b></div>';
      }).join('') + '</div></div></section>';
    h += vistaAgente(r);
    h += recorrido(r);
    if (ai.voice) {
      h += '<section class="lgia__card lgia__voice"><h2 class="lgia__h2">' + esc(t('voice.title')) + '</h2><div class="lgia__chat"><div class="lgia__avatar" aria-hidden="true">' + ROBOT + '</div>' +
        '<div class="lgia__bubble"><p class="lgia__who">' + esc(t('voice.who')) + '</p><p class="lgia__said" data-voice="' + esc(ai.voice) + '">' + esc(ai.voice) + '</p></div></div>' +
        '<p class="lgia__fine">' + esc(t('voice.note')) + '</p></section>';
    }
    h += '<div class="lgia__grid3">' + ['buy', 'understand', 'trust'].map(function (g) { return grupo(r, g); }).join('') + '</div>';
    h += ucp(r);
    h += consentimiento(r);
    h += cta(r);
    h += '<p class="lgia__disc">' + esc(t('disclaimer')) + (r.cached ? ' ' + esc(t('cached')) : '') + '</p>';
    h += '<p class="lgia__again"><button type="button" class="lgia__btn lgia__btn--ghost" data-again>' + esc(t('again')) + '</button></p>';
    out.innerHTML = h;
    animar(r);
    enlazar(r);
  }

  /* Vista del agente: la captura con rayos X (deslizador) y, al lado, lo que lee y los datos estructurados. */
  function vistaAgente(r) {
    var v = r.view || {};
    var h = '<section class="lgia__card lgia__view"><h2 class="lgia__h2">' + esc(t('view.title')) + '</h2><p class="lgia__sub">' + esc(t('view.lead')) + '</p>';
    if (r.nav_error || !v.shot) h += '<p class="lgia__msg">' + esc(t('view.fallback')) + '</p>';
    h += '<div class="lgia__view-grid">';
    if (v.shot) {
      var W = v.ancho || 1280, H = v.alto || 1700;
      var cajas = (v.cajas || []).map(function (c) {
        return '<div class="lgia__box ' + (c.ok ? 'is-ok' : 'is-bad') + '" style="left:' + (c.x / W * 100) + '%;top:' + (c.y / H * 100) + '%;width:' + (c.w / W * 100) + '%;height:' + (c.h / H * 100) + '%">' +
          '<span>' + (c.ok ? '✓ ' : '✕ ') + esc(t('box.' + c.k) || c.k) + '</span></div>';
      }).join('');
      h += '<div class="lgia__xr-wrap"><div class="lgia__xr-legend"><span>' + esc(t('view.you')) + '</span><span>' + esc(t('view.agent')) + '</span></div>' +
        '<div class="lgia__xr-scroll"><div class="lgia__xr" style="aspect-ratio:' + W + '/' + H + ';--pos:50%">' +
        '<img src="' + esc(API + v.shot) + '" alt="' + esc(r.host) + '" loading="lazy" width="' + W + '" height="' + H + '">' +
        '<div class="lgia__xr-agent" aria-hidden="true"><img src="' + esc(API + v.shot) + '" alt="" width="' + W + '" height="' + H + '">' + cajas + '</div>' +
        '<div class="lgia__xr-handle" aria-hidden="true"><span>⟷</span></div></div></div>' +
        '<input class="lgia__xr-range" type="range" min="0" max="100" value="50" aria-label="' + esc(t('view.slider')) + '">' +
        '<p class="lgia__keys"><span class="is-ok">' + esc(t('view.legend_ok')) + '</span><span class="is-bad">' + esc(t('view.legend_bad')) + '</span></p></div>';
    }
    h += '<div class="lgia__reads">';
    if (v.lectura && v.lectura.length) {
      h += '<h3>' + esc(t('view.reads')) + '</h3><p class="lgia__fine">' + esc(t('view.reads_lead')) + '</p><ul class="lgia__ax">' + v.lectura.map(function (l, i) {
        var rol = t('roles.' + l.role) || l.role;
        if (l.role === 'heading' && l.level) rol += ' ' + l.level;
        return '<li class="' + (l.bad ? 'is-bad' : '') + '" style="--i:' + i + ';--d:' + (l.depth || 0) + '"><span class="lgia__role">' + esc(rol) + '</span>' +
          (l.bad ? '<em>' + esc(t('view.noname')) + '</em>' : esc(l.name)) + (l.n > 1 ? ' <small>' + esc(t('view.repeat', { n: l.n })) + '</small>' : '') + '</li>';
      }).join('') + '</ul>';
    }
    var d = v.datos;
    h += '<h3>' + esc(t('view.data')) + '</h3>';
    if (!d) h += '<p class="lgia__msg lgia__msg--err">' + esc(t('view.data_none')) + '</p>';
    else {
      h += '<p class="lgia__fine">' + esc(t('view.data_lead')) + '</p><dl class="lgia__ld">' + ['name', 'price', 'availability', 'brand', 'gtin', 'sku', 'source'].map(function (k) {
        var val = d[k], ok = !!val;
        if (k === 'price' && val) val = val + (d.currency ? ' ' + d.currency : '');
        if (val === true) val = t('view.yes');
        if (!val) val = t('view.no');
        if (k === 'source') { val = d.source === 'microdata' ? 'microdata' : 'JSON-LD'; ok = d.source !== 'microdata'; }
        return '<div class="' + (ok ? 'is-ok' : 'is-bad') + '"><dt>' + esc(t('view.fields.' + k)) + '</dt><dd>' + (ok ? '✓ ' : '✕ ') + esc(dec(val)) + '</dd></div>';
      }).join('') + '</dl>';
    }
    return h + '</div></div></section>';
  }

  function recorrido(r) {
    var j = r.journey || { steps: [] }, ai = r.ai || {};
    var porId = {};
    (r.items || []).forEach(function (i) { porId[i.id] = i; });
    var stuck = j.stuck ? j.steps.filter(function (s) { return s.id === j.stuck; })[0] : null;
    var dudas = j.steps.filter(function (s) { return s.status === 'warn' || s.status === 'fail'; });
    var frase = stuck ? (ai.stuck || (stuck.reason ? t('items.' + stuck.reason + '.t') + '.' : '')) + (r.cap ? ' ' + t('journey.cap', { n: r.cap }) : '') : dudas.length ?
      t('journey.doubts', { steps: dudas.map(function (s) { return '«' + t('journey.steps.' + s.id) + '»'; }).join(', ') }) + (ai.stuck ? ' ' + ai.stuck : '') : t('journey.ok_all');
    return '<section class="lgia__card lgia__journey"><h2 class="lgia__h2">' + esc(t('journey.title')) + '</h2><p class="lgia__sub">' + esc(t('journey.lead')) + '</p>' +
      '<ol class="lgia__steps">' + j.steps.map(function (s, k) {
        var it = s.reason && porId[s.reason];
        var tip = s.status === 'skip' ? t('journey.skip') : it ? t('items.' + s.reason + '.t') + ' · ' + t('status.' + s.status) : t('status.' + s.status);
        return '<li class="lgia__step is-' + s.status + (s.after ? ' is-after' : '') + (stuck && s.id === stuck.id ? ' is-stuck' : '') + '" style="--k:' + k + '" title="' + esc(tip) + '">' +
          '<span class="lgia__step-dot">' + ico(s.status) + '</span><span class="lgia__step-name">' + esc(t('journey.steps.' + s.id)) + '</span></li>';
      }).join('') + '</ol><div class="lgia__agent-dot" aria-hidden="true">' + ROBOT + '</div>' +
      '<p class="lgia__stuck ' + (stuck ? 'is-bad' : dudas.length ? 'is-warn' : 'is-ok') + '">' + (stuck ? '<b>' + esc(t('journey.stuck', { step: t('journey.steps.' + stuck.id) })) + '.</b> ' + esc(frase) : esc(frase)) + '</p>' +
      '<button type="button" class="lgia__link" data-replay>↻ ' + esc(t('journey.play')) + '</button></section>';
  }

  function item(i, r) {
    var ev = i.ev || {};
    var vars = { bots: (ev.bots || []).join(', '), missing: (ev.missing || []).join(', '), n: ev.n || '', text: ev.text || '', platform: ev.platform || '', lang: idioma(ev.lang), store: idioma(ev.store) };
    var fix = '';
    if (i.status === 'warn' || i.status === 'fail' || i.status === 'probable' || ((i.status === 'info' || i.status === 'na') && INFO_TXT[i.id])) {
      var k = ev.variant && t('items.' + i.id + '.fix_' + ev.variant) ? 'fix_' + ev.variant : i.id === 'buy_button' && ev.external ? 'fix_external' : i.id === 'buy_button' && i.status === 'probable' ? 'fix_probable' : i.id === 'consent_privacy' && ev.lang ? 'fix_lang' : 'fix';
      // Si el texto pinta una lista ({missing}, {bots}) y viene vacía, va su variante sin lista (fix_none).
      var lista = t('items.' + i.id + '.' + k).match(/\{(missing|bots)\}/);
      if (lista && !vars[lista[1]] && t('items.' + i.id + '.fix_none')) k = 'fix_none';
      fix = t('items.' + i.id + '.' + k, vars);
    }
    // Informativos en verde: su texto de «bien»
    if (i.status === 'ok' && INFO_TXT[i.id]) fix = t('items.' + i.id + '.ok', vars);
    var chips = '';
    if (i.id === 'refund' || i.id === 'shipping') chips = ['plazo', 'coste'].map(function (k) { return '<span class="' + (ev[k] ? 'is-ok' : 'is-bad') + '">' + (ev[k] ? '✓ ' : '✕ ') + esc(t('ev.' + (k === 'plazo' ? 'deadline' : 'cost'))) + '</span>'; }).join('');
    if (i.id === 'gtin') chips = ['gtin', 'mpn', 'sku'].map(function (k) { return '<span class="' + (ev[k] ? 'is-ok' : 'is-bad') + '">' + (ev[k] ? '✓ ' : '✕ ') + k.toUpperCase() + '</span>'; }).join('');
    if (ev.capabilities) chips = ev.capabilities.slice(0, 8).map(function (c) { return '<span class="is-ok">' + esc(c) + '</span>'; }).join('');
    if (ev.cmp) chips = '<span class="is-ok">' + esc(ev.cmp) + '</span>';
    if (i.id === 'llms' && ev.invalid && ev.text) chips = '<span class="is-bad">✕ ' + esc(ev.text) + '</span>';
    if (ev.answers) chips = ev.answers.filter(function (a) { return a.known !== null; }).map(function (a) { return '<span class="' + (a.known ? 'is-ok' : 'is-bad') + '" title="' + esc(a.answer || '') + '">' + (a.known ? '✓ ' : '✕ ') + esc(t('items.' + a.kind + '.t')) + '</span>'; }).join('');
    if (ev.handlers) chips = ev.handlers.map(function (c) { return '<span class="is-ok">' + esc(c) + '</span>'; }).join('');
    if (ev.version) chips = '<span class="is-ok">v' + esc(ev.version) + '</span>' + (ev.transports || []).map(function (c) { return '<span class="is-ok">' + esc(c) + '</span>'; }).join('');
    var link = ev.url ? ' <a class="lgia__link" href="' + esc(ev.url) + '" target="_blank" rel="noopener nofollow">' + esc(t('ev.see')) + ' ↗</a>' : '';
    var modulo = PS_URL && r.platform === 'prestashop' && MODULO_ARREGLA[i.id] && (i.status === 'fail' || i.status === 'warn') ?
      '<a class="lgia__mod" href="' + esc(PS_URL) + '">' + esc(t('module_fixes', { name: t('ps_module.name') })) + ' →</a>' : '';
    return '<li class="lgia__item is-' + i.status + '"><span class="lgia__ico">' + ico(i.status) + '</span><div><p class="lgia__item-t">' + esc(t('items.' + i.id + '.t')) +
      ' <span class="lgia__st">' + esc(t('status.' + i.status)) + '</span>' + link + '</p>' +
      (chips ? '<p class="lgia__chips">' + chips + '</p>' : '') + (fix ? '<p class="lgia__fix">' + esc(fix) + '</p>' : '') + modulo + '</div></li>';
  }
  // Nombre del idioma en el de la página («en» → «inglés»).
  function idioma(c) {
    if (!c) return '';
    try { return new Intl.DisplayNames([LANG], { type: 'language' }).of(c); } catch (e) { return c; }
  }
  function lista(r, g) {
    return (r.items || []).filter(function (i) { return i.group === g; })
      .sort(function (a, b) { return ORDEN[a.status] - ORDEN[b.status]; })
      .map(function (i) { return item(i, r); }).join('');
  }
  function grupo(r, g) {
    var n = r.groups[g];
    return '<section class="lgia__card lgia__group"><header><h2 class="lgia__h3">' + esc(t('groups.' + g + '.t')) + '</h2><b class="lgia__pill lgia--' + nivel(n) + '">' + num(n) + '</b></header>' +
      '<p class="lgia__fine">' + esc(t('groups.' + g + '.d')) + '</p><ul class="lgia__items">' + lista(r, g) + '</ul></section>';
  }
  // Consentimiento del comprador para agentes (solo Shopify; nota aparte, como UCP).
  function consentimiento(r) {
    if (!(r.items || []).some(function (i) { return i.group === 'consent'; })) return '';
    var n = r.groups.consent;
    return '<section class="lgia__card lgia__ucp lgia__consent"><header><h2 class="lgia__h2">' + esc(t('consent.title')) + '</h2><b class="lgia__pill lgia--' + nivel(n) + '">' + num(n) + '</b></header>' +
      '<p class="lgia__sub">' + esc(t('consent.lead')) + '</p><ul class="lgia__items lgia__items--2">' + lista(r, 'consent') + '</ul></section>';
  }
  function ucp(r) {
    var n = r.groups.ucp;
    return '<section class="lgia__card lgia__ucp"><header><h2 class="lgia__h2">' + esc(t('ucp.title')) + '</h2><b class="lgia__pill lgia--' + nivel(n) + '">' + num(n) + '</b></header>' +
      '<p class="lgia__sub">' + esc(t('ucp.lead')) + '</p><p class="lgia__us">' + esc(t('ucp.us')) + '</p><ul class="lgia__items lgia__items--2">' + lista(r, 'ucp') + '</ul></section>';
  }
  function cta(r) {
    var ps = PS_URL && r.platform === 'prestashop';
    var h = '';
    var priv = '<a href="' + esc(PRIVACY) + '" target="_blank" rel="noopener">' + esc(t('lead.privacy')) + '</a>';
    // Un solo bloque: la llamada (título y texto) arriba y el formulario debajo, en un panel claro
    h += '<section class="lgia__card lgia__cta-main lgia__lead-box" id="lgia-lead"><h2 class="lgia__h2">' + esc(t('cta.title')) + '</h2><p class="lgia__cta-text">' + esc(t('cta.text')) + '</p>' +
      '<form class="lgia__lead lgia__lead-panel" novalidate><div class="lgia__row"><label>' + esc(t('lead.name')) + '<input name="name" type="text" autocomplete="name" maxlength="120"></label>' +
      '<label>' + esc(t('lead.email')) + ' *<input name="email" type="email" autocomplete="email" maxlength="120" required aria-describedby="lgia-lead-msg"></label>' +
      '<label>' + esc(t('lead.phone')) + ' *<input name="phone" type="tel" autocomplete="tel" maxlength="40" required aria-describedby="lgia-lead-msg"></label></div>' +
      '<label>' + esc(t('lead.message')) + '<textarea name="message" rows="3" maxlength="1000"></textarea></label>' +
      '<label class="lgia__hp" aria-hidden="true">Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label>' +
      '<label class="lgia__check"><input name="consent" type="checkbox" aria-describedby="lgia-lead-msg"> <span>' + esc(t('lead.consent')).replace('{privacy}', priv) + '</span></label>' +
      '<p class="lgia__lead-msg" id="lgia-lead-msg" role="alert"></p>' +
      '<div class="lgia__lead-send"><button class="lgia__btn" type="submit">' + esc(t('lead.send')) + '</button><p class="lgia__trust">' + esc(t('lead.trust')) + '</p></div></form></section>';
    if (ps) h += '<section class="lgia__card lgia__cta-ps"><h3 class="lgia__h3">' + esc(t('cta.ps_title')) + '</h3><p>' + esc(t('cta.ps_text', { name: t('ps_module.name') })) + '</p>' +
      '<a class="lgia__btn lgia__btn--ghost" href="' + esc(PS_URL) + '">' + esc(t('cta.ps_button')) + '</a></section>';
    return h;
  }

  /* ---------- Animaciones ---------- */
  function animar(r) {
    var ring = out.querySelector('.lgia__ring'), num = ring.querySelector('[data-count]');
    var fin = r.score, t0 = null, dur = REDUCED ? 1 : 1100;
    (function f(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3), v = Math.round(fin * e);
      num.textContent = v; ring.style.setProperty('--p', v);
      if (p < 1) requestAnimationFrame(f);
    })(performance.now());
    var xr = out.querySelector('.lgia__xr');
    if (xr && !REDUCED) visible(xr, function () { barrido(xr); });
    var jr = out.querySelector('.lgia__journey');
    if (jr) visible(jr, function () { andar(jr); });
    var said = out.querySelector('[data-voice]');
    if (said && !REDUCED) visible(said, function () { teclear(said); });
  }
  function ponPos(xr, p) {
    p = Math.max(0, Math.min(100, p));
    xr.style.setProperty('--pos', p + '%');
    var rg = out.querySelector('.lgia__xr-range');
    if (rg) rg.value = Math.round(p);
  }
  function barrido(xr) {
    var t0 = null;
    (function f(ts) {
      if (!t0) t0 = ts;
      var s = (ts - t0) / 1000;
      // 100 → 0 → 30: el agente barre la ficha entera y se queda con la mayor parte a la vista.
      var p = s < 1.2 ? 100 - (s / 1.2) * 100 : s < 2 ? ((s - 1.2) / 0.8) * 30 : 30;
      ponPos(xr, p);
      if (s < 2) requestAnimationFrame(f);
    })(performance.now());
  }
  function andar(jr) {
    var pasos = [].slice.call(jr.querySelectorAll('.lgia__step')), dot = jr.querySelector('.lgia__agent-dot'), msg = jr.querySelector('.lgia__stuck');
    var paso = REDUCED ? 0 : 520, k = 0;
    jr.classList.remove('is-done');
    pasos.forEach(function (p) { p.classList.remove('is-on'); });
    msg.classList.remove('is-on');
    (function sig() {
      var p = pasos[k];
      if (!p) { jr.classList.add('is-done'); msg.classList.add('is-on'); return; }
      p.classList.add('is-on');
      var a = p.querySelector('.lgia__step-dot').getBoundingClientRect(), b = jr.getBoundingClientRect();
      dot.style.transform = 'translate(' + (a.left - b.left + a.width / 2 - 14) + 'px,' + (a.top - b.top - 32) + 'px)';
      dot.classList.add('is-on');
      if (p.classList.contains('is-stuck')) { dot.classList.add('is-stuck'); jr.classList.add('is-done'); msg.classList.add('is-on'); return; }
      k++;
      setTimeout(sig, paso);
    })();
  }
  function teclear(el) {
    var txt = el.getAttribute('data-voice'), i = 0;
    el.textContent = '';
    el.classList.add('is-typing');
    (function f() {
      i += 2;
      el.textContent = txt.slice(0, i);
      if (i < txt.length) setTimeout(f, 18); else el.classList.remove('is-typing');
    })();
  }

  /* ---------- Compartir: el informe por email ---------- */
  // Para compartir el resultado hay que dar el email: se le manda el enlace por correo y después sale aquí para copiarlo.
  function pedirInforme(r, origen) {
    var previo = document.activeElement, guardado = '';
    try { guardado = localStorage.getItem('lg_tool_email') || ''; } catch (e) {}
    var priv = '<a href="' + esc(PRIVACY) + '" target="_blank" rel="noopener">' + esc(t('lead.privacy')) + '</a>';
    var m = document.createElement('div');
    m.className = 'lgia lgia__modal';
    m.innerHTML = '<div class="lgia__modal-box lgia__mail" role="dialog" aria-modal="true" aria-labelledby="lgia-mail-t" aria-describedby="lgia-mail-d" tabindex="-1">' +
      '<button type="button" class="lgia__modal-x" data-cancel aria-label="' + esc(t('mail.close')) + '">×</button>' +
      '<h2 class="lgia__h2" id="lgia-mail-t">' + esc(t('mail.title')) + '</h2><p class="lgia__sub" id="lgia-mail-d">' + esc(t('mail.text', { host: r.host })) + '</p>' +
      '<form class="lgia__lead lgia__mail-form" novalidate><label>' + esc(t('lead.email')) + ' *<input name="email" type="email" autocomplete="email" maxlength="120" required aria-describedby="lgia-mail-msg" value="' + esc(guardado) + '"></label>' +
      '<label class="lgia__hp" aria-hidden="true">Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label>' +
      '<label class="lgia__check"><input name="privacy" type="checkbox" required aria-describedby="lgia-mail-msg"> <span>' + esc(t('lead.consent')).replace('{privacy}', priv) + ' *</span></label>' +
      '<label class="lgia__check"><input name="marketing" type="checkbox"> <span>' + esc(t('mail.marketing')) + '</span></label>' +
      '<p class="lgia__lead-msg" id="lgia-mail-msg" role="alert"></p>' +
      '<button class="lgia__btn" type="submit">' + esc(t('mail.send')) + '</button></form></div>';
    document.body.appendChild(m);
    var box = m.querySelector('.lgia__modal-box'), lf = box.querySelector('form');
    var cerrar = function () { document.removeEventListener('keydown', tecla); m.remove(); if (previo && previo.focus) previo.focus(); };
    var tecla = function (ev) {
      if (ev.key === 'Escape') cerrar();
      if (ev.key === 'Tab') { // foco dentro del modal
        var f = [].slice.call(box.querySelectorAll('button, input:not([tabindex="-1"]), a[href]'));
        if (!f.length) return;
        if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
        else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
      }
    };
    document.addEventListener('keydown', tecla);
    m.addEventListener('click', function (ev) { if (ev.target === m) cerrar(); });
    m.querySelector('[data-cancel]').addEventListener('click', cerrar);
    lf.elements.email.focus();
    lf.addEventListener('change', function (ev) { var g = lf.querySelector('.lgia__lead-msg'); if (ev.target.checked || ev.target.name === 'email') { g.textContent = ''; g.className = 'lgia__lead-msg'; ev.target.removeAttribute('aria-invalid'); } });
    ga('ia_check_share_open', { score: r.score, from: origen });
    lf.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var f = lf.elements, msg = lf.querySelector('.lgia__lead-msg'), b = lf.querySelector('button[type=submit]');
      var mal = function (texto, campo) {
        msg.className = 'lgia__lead-msg is-bad'; msg.textContent = texto;
        [f.email, f.privacy].forEach(function (c) { c.removeAttribute('aria-invalid'); });
        if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
      };
      var email = f.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return mal(t('lead.err_email'), f.email);
      if (!f.privacy.checked) return mal(t('lead.err_consent'), f.privacy);
      mal('', null); msg.className = 'lgia__lead-msg';
      var qs = new URLSearchParams(location.search);
      var body = { id: r.id, lang: LANG, email: email, privacy: true, marketing: f.marketing.checked, website: f.website.value,
        utm_source: qs.get('utm_source') || '', utm_medium: qs.get('utm_medium') || '', utm_campaign: qs.get('utm_campaign') || '', gclid: qs.get('gclid') || '',
        referrer: document.referrer || '', landing: location.href.split('#')[0] };
      b.disabled = true; b.setAttribute('aria-busy', 'true');
      api('/api/agentes/informe', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }).then(function (res) {
        b.disabled = false; b.removeAttribute('aria-busy');
        if (res && res.ok) {
          try { localStorage.setItem('lg_tool_email', email); } catch (e) {}
          ga('ia_check_share', { score: r.score, platform: r.platform, marketing: f.marketing.checked ? 1 : 0 });
          return hecho(res.mail !== false, email, res.pdf);
        }
        if (res && res.error === 'email') mal(t('lead.err_email'), f.email);
        else if (res && res.error === 'privacy') mal(t('lead.err_consent'), f.privacy);
        else if (res && res.error === 'rate') mal(t('mail.err_rate'), null);
        else mal(t('lead.err_generic'), null);
      });
    });
    // Enviado: el enlace para copiar (el de compartir, con la tarjeta de la nota) y, si el móvil sabe, compartir.
    function hecho(mandado, email, pdf) {
      var url = API + '/ia/r/' + r.id + '?lang=' + LANG;
      box.innerHTML = '<button type="button" class="lgia__modal-x" data-cancel aria-label="' + esc(t('mail.close')) + '">×</button>' +
        '<h2 class="lgia__h2" id="lgia-mail-t">' + esc(t(mandado ? 'mail.ok_title' : 'mail.nomail_title')) + '</h2>' +
        '<p class="lgia__sub" id="lgia-mail-d" role="status">' + esc(t(mandado ? 'mail.ok' : 'mail.nomail', { email: email })) + '</p>' +
        '<div class="lgia__copy"><label class="lgia__sr" for="lgia-mail-url">' + esc(t('mail.link')) + '</label><input id="lgia-mail-url" type="text" readonly value="' + esc(url) + '">' +
        '<button type="button" class="lgia__btn" data-copy>' + esc(t('mail.copy')) + '</button></div>' +
        (pdf ? '<a class="lgia__btn" href="' + esc(pdf) + '" target="_blank" rel="noopener" download>' + esc(t('mail.download')) + '</a> ' : '') +
        (navigator.share ? '<button type="button" class="lgia__btn lgia__btn--ghost" data-native>' + esc(t('share')) + '</button>' : '');
      box.querySelector('[data-cancel]').addEventListener('click', cerrar);
      var inp = box.querySelector('input'), cp = box.querySelector('[data-copy]');
      inp.addEventListener('focus', function () { inp.select(); });
      cp.addEventListener('click', function () {
        var ok = function () { cp.textContent = t('copied'); setTimeout(function () { cp.textContent = t('mail.copy'); }, 1600); };
        inp.select();
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(ok, function () { try { document.execCommand('copy'); ok(); } catch (e) {} });
        else { try { document.execCommand('copy'); ok(); } catch (e) {} }
      });
      var nt = box.querySelector('[data-native]');
      if (nt) nt.addEventListener('click', function () { navigator.share({ title: t('title'), text: r.host + ' · ' + r.score + '/100', url: url }).catch(function () {}); });
      cp.focus();
    }
  }

  /* ---------- Eventos del resultado ---------- */
  function enlazar(r) {
    var xr = out.querySelector('.lgia__xr'), rg = out.querySelector('.lgia__xr-range');
    if (xr && rg) {
      rg.addEventListener('input', function () { ponPos(xr, +rg.value); });
      var arrastra = false;
      var mover = function (ev) { var b = xr.getBoundingClientRect(); ponPos(xr, (ev.clientX - b.left) / b.width * 100); };
      var hd = xr.querySelector('.lgia__xr-handle');
      hd.addEventListener('pointerdown', function (ev) { arrastra = true; hd.setPointerCapture(ev.pointerId); ev.preventDefault(); });
      hd.addEventListener('pointermove', function (ev) { if (arrastra) mover(ev); });
      hd.addEventListener('pointerup', function () { arrastra = false; });
      xr.addEventListener('click', function (ev) { if (ev.target === hd || hd.contains(ev.target)) return; mover(ev); });
    }
    var rp = out.querySelector('[data-replay]');
    if (rp) rp.addEventListener('click', function () { var jr = out.querySelector('.lgia__journey'); jr.querySelector('.lgia__agent-dot').classList.remove('is-stuck'); andar(jr); });
    var sh = out.querySelector('[data-share]');
    if (sh) sh.addEventListener('click', function () { pedirInforme(r, 'top'); });
    var ag = out.querySelector('[data-again]');
    if (ag) ag.addEventListener('click', function () { input.value = ''; try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} out.innerHTML = ''; root.scrollIntoView({ behavior: 'smooth' }); input.focus(); });
    var lf = out.querySelector('.lgia__lead');
    if (lf) lf.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var f = lf.elements, msg = lf.querySelector('.lgia__lead-msg'), b = lf.querySelector('button');
      var mal = function (texto, campo) {
        msg.className = 'lgia__lead-msg is-bad'; msg.textContent = texto;
        [f.email, f.phone, f.consent].forEach(function (c) { c.removeAttribute('aria-invalid'); });
        if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
      };
      var email = f.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return mal(t('lead.err_email'), f.email);
      if (!/^(?=(?:\D*\d){6,20}\D*$)[+\d\s().-]{6,40}$/.test(f.phone.value.trim())) return mal(t('lead.err_phone'), f.phone);
      if (!f.consent.checked) return mal(t('lead.err_consent'), f.consent);
      mal('', null); msg.className = 'lgia__lead-msg';
      var qs = new URLSearchParams(location.search);
      var body = { id: r.id, lang: LANG, name: f.name.value.trim(), email: email, phone: f.phone.value.trim(), message: f.message.value.trim(), website: f.website.value, consent: true,
        utm_source: qs.get('utm_source') || '', utm_medium: qs.get('utm_medium') || '', utm_campaign: qs.get('utm_campaign') || '', gclid: qs.get('gclid') || '',
        referrer: document.referrer || '', landing: location.href.split('#')[0] };
      b.disabled = true; b.setAttribute('aria-busy', 'true');
      api('/api/agentes/lead', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }).then(function (res) {
        b.disabled = false; b.removeAttribute('aria-busy');
        if (res && res.ok) {
          ga('ia_check_lead', { score: r.score, platform: r.platform });
          lf.innerHTML = '<p class="lgia__msg lgia__msg--ok lgia__lead-ok" role="status" tabindex="-1">' + esc(t('lead.ok')) + '</p>';
          lf.firstChild.focus({ preventScroll: true });
        } else if (res && res.error === 'email') mal(t('lead.err_email'), f.email);
        else if (res && res.error === 'phone') mal(t('lead.err_phone'), f.phone);
        else if (res && res.error === 'consent') mal(t('lead.err_consent'), f.consent);
        else mal(t('lead.err_generic'), null);
      });
    });
  }

  var ROBOT = '<svg viewBox="0 0 32 32" width="28" height="28"><rect x="5" y="9" width="22" height="17" rx="6" fill="currentColor"/><circle cx="12" cy="17" r="2.6" fill="#fff"/><circle cx="20" cy="17" r="2.6" fill="#fff"/>' +
    '<rect x="12" y="21.5" width="8" height="1.8" rx=".9" fill="#fff"/><rect x="15" y="3" width="2" height="6" fill="currentColor"/><circle cx="16" cy="3" r="2" fill="currentColor"/></svg>';

  // Enlace compartido: #r=<id>
  var m = /[#&]r=([A-Za-z0-9_-]{6,20})/.exec(location.hash);
  if (m) { btn.disabled = true; if (!out.hasAttribute('data-wait')) cargando('ai'); seguir(m[1]); } // el spinner lo pone la sección
})();
